import PropTypes from "prop-types";

export const ObservationImageAttributes = {
  full_path: PropTypes.string.isRequired,
  thumbnail_full_path: PropTypes.string,
};

export const ObservationImageType = PropTypes.shape(ObservationImageAttributes);

export const ObservationAssetTypeAttributes = {
  id: PropTypes.number,
  name: PropTypes.string,
};

export const ObservationAssetTypeType = PropTypes.shape(
  ObservationAssetTypeAttributes
);

export const ObservationAssetAttributes = {
  id: PropTypes.number,
  name: PropTypes.string,
  asset_type: ObservationAssetTypeType,
};

export const ObservationAssetType = PropTypes.shape(ObservationAssetAttributes);

export const ObservationCoordinatesAttributesType = {
  coordinates: PropTypes.string,
  source_url: PropTypes.string,
};

export const ObservationGPSAttributesType = {
  coordinates: PropTypes.string,
};

export const ObservationCoordinatesAttributes = {
  plan_positioning: PropTypes.shape(ObservationCoordinatesAttributesType),
  cartesian: PropTypes.shape(ObservationCoordinatesAttributesType),
  gps: PropTypes.shape(ObservationGPSAttributesType),
};

export const ObservationCoordinatesType = PropTypes.shape(
  ObservationCoordinatesAttributes
);

export const ObservationAttributes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  pictures: PropTypes.arrayOf(ObservationImageType),
  coordinates: ObservationCoordinatesType,
  asset: ObservationAssetType,
};

export const ObservationItem = PropTypes.shape(ObservationAttributes);
